"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Form_exports = {};
__export(Form_exports, {
  Form: () => Form
});
module.exports = __toCommonJS(Form_exports);
var import_react = __toESM(require("react"));
var import_react_hook_form = require("react-hook-form");
var import_ServerErrorsContext = require("./ServerErrorsContext");
function FormInner({
  config,
  error: errorProps,
  formMethods: propFormMethods,
  onSubmit,
  children,
  ...rest
}, ref) {
  const hookFormMethods = (0, import_react_hook_form.useForm)(config);
  const formMethods = propFormMethods || hookFormMethods;
  return /* @__PURE__ */ import_react.default.createElement(
    "form",
    {
      ref,
      ...rest,
      onSubmit: formMethods.handleSubmit(
        (data, event) => onSubmit?.(data, event)
      )
    },
    /* @__PURE__ */ import_react.default.createElement(
      import_ServerErrorsContext.ServerErrorsContext.Provider,
      {
        value: errorProps?.graphQLErrors?.[0]?.extensions?.properties?.messages || {}
      },
      /* @__PURE__ */ import_react.default.createElement(import_react_hook_form.FormProvider, { ...formMethods }, children)
    )
  );
}
const Form = (0, import_react.forwardRef)(FormInner);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Form
});
